import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import { FaLinkedin, FaEnvelope, FaChevronDown, FaChevronUp, FaMicrosoft, FaFileUpload, FaTimes, FaGithub, FaSass } from 'react-icons/fa';
import { SiSap, SiOpensourceinitiative, } from 'react-icons/si';
import { ToastContainer, toast } from 'react-toastify';
import header from '../assets/header.png'
// import Vorstel from '../assets/Vorstel-logo.png';
// import Website-header from '../assets/Websiteheader.png'
import { Link } from 'react-router-dom';

const Navbar = ({ onActiveTabChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('HeroSection');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showCareersModal, setShowCareersModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1024));
  const [selectedCareerType, setSelectedCareerType] = useState('fullTime');
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: '',
    position: '',
    skills: [],
    coverLetter: '',
    resumes: [],
    careerType: '',
  });

  const careerTypes = [
    { id: 'fullTime', label: 'Full Time' },
    { id: 'partTime', label: 'Part Time' },
    { id: 'internship', label: 'Internship' },
    { id: 'freelance', label: 'Freelance' }
  ];

  const skillOptions = [
    { id: 'react', label: 'React' },
    { id: 'devops', label: 'DevOps' },
    { id: 'sap', label: 'SAP', icon: <SiSap className="inline ml-1" /> },
    { id: 'openSource', label: 'Open Source', icon: <SiOpensourceinitiative className="inline ml-1" /> },
    { id: 'uiux', label: 'UI/UX Design' },
    { id: 'cloud', label: 'Cloud Computing' },
    { id: 'ai', label: 'AI/ML' },
    { id: 'others', label: `Other's` }

  ];

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth >= 768) {
        setIsOpen(false);
      }
    };

    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);

      const sections = ['HeroSection', 'AboutSection', 'Consulting', 'DesignServices', 'Gen', 'ContactUs'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollTo = (id, isService) => {
    if (isService) {
      onActiveTabChange(id);
      const element = document.getElementById('all');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveSection(id);
        setIsOpen(false);
      }
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActiveSection(id);
        setIsOpen(false);
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setActiveSection('HeroSection');
  };

  const toggleMenu = () => setIsOpen(!isOpen);

  // Handle text input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  // Handle skill selection toggle
  const handleSkillToggle = (skillId) => {
    setFormData((prev) => {
      const skills = prev.skills.includes(skillId)
        ? prev.skills.filter((id) => id !== skillId)
        : [...prev.skills, skillId];
      return { ...prev, skills };
    });
  };

  // Handle file input changes
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({ ...prev, resumes: files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();

    // Append all your form fields
    form.append("name", formData.name);
    form.append("email", formData.email);
    form.append("phone", formData.phone);
    form.append("experience", formData.experience);
    form.append("position", formData.position);
    form.append("coverLetter", formData.coverLetter);
    form.append("skills", JSON.stringify(formData.skills));
    formData.resumes.forEach((file) => form.append("resume[]", file));

    try {
      const response = await fetch("https://vorstel.com/apply.php", {
        method: "POST",
        body: form,
      });

      const status = response.status;
      let data;

      // Try parsing JSON only if response has body
      try {
        data = await response.json();
      } catch (jsonError) {
        data = {};
      }

      console.log("Status Code:", status);
      console.log("Response Data:", data);

      if (status === 200) {
        toast.success(data.message || "Application submitted successfully!");

        // Reset form after successful submission
        setFormData({
          name: '',
          email: '',
          phone: '',
          experience: '',
          position: '',
          coverLetter: '',
          skills: [],
          resumes: []
        });

        // If you're using a form ref to access the DOM element directly
        if (e.target) {
          e.target.reset();
        }
      } else if (status === 400 || status === 422) {
        toast.error(data.message || "Missing or invalid form data.");
      } else if (status === 500) {
        toast.error(data.message || "Server error. Please try again later.");
      } else {
        toast.error("Something went wrong. Code: " + status);
      }

    } catch (err) {
      console.error("Network error:", err);
      toast.error("Network error. Please check your connection.");
    }
  };
  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  // Services dropdown items
  // const services = [
  //   { id: 'all', label: 'Digital & IT Solutions' },
  //   { id: 'sap', label: 'SAP Transformation & Migration' },
  //   { id: 'gen', label: 'GenAI & ML' },
  //   // { id: 'DesignServices', label: 'UI/UX Design' },
  //   // { id: 'DesignServices', label: 'Digital Transformation' },
  //   // { id: 'DesignServices', label: ' IT Consulting' },
  //   // { id: 'DesignServices', label: 'Business Transformation' }
  // ];


  return (
    <>
      <nav className="bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 fixed w-full top-0 z-50">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <div className="w-auto flex-shrink-0">
            <Link to="/">
              <img
                src={header}
                alt="Vorstel logo"
                width="160"
                height="40"
                className="w-[160px] h-auto object-contain cursor-pointer hover:opacity-80 transition-opacity"
              />
            </Link>
          </div>

          {/* Center Navigation */}
          {!isMobile && (
            <div
              className={`flex items-center font-bolder ${isTablet ? 'space-x-4' : 'space-x-6'
                }`}
            >
              {[
                { id: 'HeroSection', label: 'Home' },
                // {
                //   id: 'training',
                //   label: 'Training',
                //   type: 'route',
                //   url: 'https://www.training.vorstel.com/',
                // },
                { id: 'Consulting', label: 'Consulting' },
                { id: 'DesignServices', label: 'Services' },
                { id: 'Gen', label: 'Gen AI & ML' },
                { id: 'AboutSection', label: 'About us' },
                {
                  id: 'Resources',
                  label: 'Resources',
                  type: 'route',
                  url: '/feeds',
                },
                { id: 'ContactUs', label: 'Contact' },
              ].map((item) => (
                <motion.button
                  key={item.id}
                  onClick={() => {
                    // If item has external route → open in new tab
                    if (item.type === 'route' && item.url) {
                      window.open(item.url, '_blank', 'noopener,noreferrer');
                    }
                    // Otherwise scroll to section
                    else {
                      scrollTo(item.id);
                    }
                  }}
                  className={`font-bold text-md sm:text-sm cursor-pointer px-2 sm:px-3 py-1 sm:py-2 transition-colors duration-300 rounded-lg ${activeSection === item.id
                    ? 'text-blue-500 font-semibold bg-indigo-50'
                    : 'text-gray-700 hover:text-blue-500 hover:bg-indigo-50'
                    }`}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {item.label}
                </motion.button>
              ))}
            </div>
          )}

          {/* Right side: Social + Button */}
          {!isMobile && (
            <div className={`flex items-center ${isTablet ? 'space-x-2' : 'space-x-4'}`}>
              <a href="mailto:sales@vorstel.com" className="p-1" aria-label="Email Vorstel sales team">
                <FaEnvelope className="text-lg sm:text-xl text-gray-700 hover:text-blue-500" aria-hidden="true" />
              </a>
              <a href="https://www.linkedin.com/company/vorstel-gmbh/about/" target="_blank" rel="noopener noreferrer" className="p-1" aria-label="Vorstel on LinkedIn (opens in a new tab)">
                <FaLinkedin className="text-lg sm:text-xl text-gray-700 hover:text-blue-500" aria-hidden="true" />
              </a>
              <button
                onClick={() => setShowCareersModal(true)}
                className="ml-2 font-medium bg-blue-500 text-white px-3 py-1 sm:px-4 sm:py-2 rounded-lg hover:bg-blue-600 transition text-xs sm:text-sm"
              >
                Careers
              </button>
            </div>
          )}

          {/* Hamburger Icon - Only shown on mobile */}
          {isMobile && (
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-gray-500 hover:text-gray-700 focus:outline-none p-2 rounded-md hover:bg-gray-100 transition"
                aria-label="Toggle menu"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          )}
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isOpen && (
            <>
              {/* Overlay that closes the menu when clicked */}
              <motion.div
                // key="overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black z-30 md:hidden"
                onClick={() => setIsOpen(false)}
              />

              {/* Mobile menu */}
              <motion.div
                key="mobile-menu"
                initial={{ x: '100%' }}
                animate={{ x: 0 }}
                exit={{ x: '100%' }}
                transition={{ duration: 0.3 }}
                className="fixed top-0 right-0 w-64 h-full bg-white shadow-lg px-6 py-10 z-40 flex flex-col space-y-6 md:hidden"
              >
                {/* Close button */}
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700"
                  aria-label="Close menu"
                >
                  ✕
                </button>

                {[
                  { id: 'HeroSection', label: 'Home' },
                  // {
                  //   id: 'training',
                  //   label: 'Training',
                  //   type: 'route',
                  //   url: 'https://www.training.vorstel.com/',
                  // },
                  { id: 'AboutSection', label: 'About Us' },
                  { id: 'Consulting', label: 'Consulting' },
                  { id: 'DesignServices', label: 'Services' },
                  { id: 'Gen', label: 'Gen AI & ML' },
                  {
                    id: 'Resources',
                    label: 'Resources',
                    type: 'route',
                    url: '/feeds',
                  },
                  { id: 'ContactUs', label: 'Contact' },
                ].map((item) => (
                  <motion.button
                    key={item.id}
                    onClick={() => {
                      if (item.type === 'route' && item.url) {
                        window.open(item.url, '_blank', 'noopener,noreferrer');
                      } else {
                        scrollTo(item.id);
                      }
                      setIsOpen(false); // close menu after click
                    }}
                    className={`text-left px-4 py-3 text-gray-700 hover:text-blue-500 font-medium rounded-lg transition ${activeSection === item.id
                      ? 'text-blue-500 font-semibold bg-indigo-50'
                      : 'hover:bg-indigo-50'
                      }`}
                    whileHover={{ x: 5 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {item.label}
                  </motion.button>
                ))}

                {/* Social + Button in Mobile */}
                <div className="flex flex-wrap gap-4 pt-4 items-center">
                  <a href="mailto:sales@vorstel.com" className="p-1" aria-label="Email Vorstel sales team">
                    <FaEnvelope className="text-lg sm:text-xl text-gray-700 hover:text-blue-500" aria-hidden="true" />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/vorstel-gmbh/about/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-1"
                    aria-label="Vorstel on LinkedIn (opens in a new tab)"
                  >
                    <FaLinkedin className="text-lg sm:text-xl text-gray-700 hover:text-blue-500" aria-hidden="true" />
                  </a>

                  <button
                    onClick={() => {
                      setShowCareersModal(true);
                      setIsOpen(false);
                    }}
                    className="bg-blue-500 font-medium text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                  >
                    Careers
                  </button>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </nav>

      {/* Careers Modal */}
      <AnimatePresence>
        {showCareersModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={() => setShowCareersModal(false)}
          >
            <motion.div
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -50, opacity: 0 }}
              className="bg-white rounded-lg w-full max-w-2xl mx-4 sm:mx-6 p-4 sm:p-6 overflow-y-auto max-h-screen"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Join Our Team</h2>
                <button
                  onClick={() => setShowCareersModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FaTimes />
                </button>
              </div>

              <div className="mb-6">
                <h3 className="text-lg font-medium text-gray-700 mb-2">Career Type</h3>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                  {careerTypes.map((type) => (
                    <button
                      key={type.id}
                      onClick={() => setSelectedCareerType(type.id)}
                      className={`py-2 px-3 rounded-md text-sm font-medium transition ${selectedCareerType === type.id
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                    >
                      {type.label}
                    </button>
                  ))}
                </div>
              </div>


              <div className="container mx-auto px-4 py-8">
                <form
                  onSubmit={handleSubmit}
                  encType="multipart/form-data" className="space-y-4" >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                        Full Name*
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                        Email*
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>

                    <div>
                      <label htmlFor="experience" className="block text-sm font-medium text-gray-700 mb-1">
                        Years of Experience*
                      </label>
                      <input
                        type="number"
                        id="experience"
                        name="experience"
                        value={formData.experience}
                        onChange={handleInputChange}
                        required
                        min="0"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="position" className="block text-sm font-medium text-gray-700 mb-1">
                      Position Applying For*
                    </label>
                    <input
                      type="text"
                      id="position"
                      name="position"
                      value={formData.position}
                      onChange={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Skills (Select all that apply)*
                    </label>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                      {skillOptions.map((skill) => (
                        <button
                          key={skill.id}
                          type="button"
                          onClick={() => handleSkillToggle(skill.id)}
                          className={`flex items-center py-2 px-3 rounded-md text-sm font-medium transition ${formData.skills.includes(skill.id)
                            ? 'bg-blue-100 text-blue-700 border border-blue-300'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                          {skill.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="resume" className="block text-sm font-medium text-gray-700 mb-1">
                        Upload File (PDF, DOC, DOCX)
                      </label>
                      <div className="flex items-center">
                        <label className="flex items-center px-3 py-1 sm:px-4 sm:py-2 bg-indigo-100 text-blue-500 rounded-md cursor-pointer hover:bg-indigo-200 transition text-sm sm:text-base">
                          <FaFileUpload className="mr-2" />
                          Choose Files
                          <input
                            type="file"
                            id="resume"
                            name="resume[]"
                            onChange={handleFileChange}
                            accept=".pdf,.doc,.docx"
                            required
                            multiple
                            className="hidden"
                          />

                        </label>
                        <span className="ml-2 text-xs sm:text-sm text-gray-500">
                          {formData.resumes && formData.resumes.length > 0
                            ? `${formData.resumes.length} file(s) selected`
                            : 'No files chosen'}
                        </span>
                      </div>

                      {/* Display list of selected files */}
                      {formData.resumes && formData.resumes.length > 0 && (
                        <div className="mt-2">
                          <ul className="text-xs sm:text-sm text-gray-600">
                            {formData.resumes.map((file, index) => (
                              <li key={index} className="truncate">
                                {file.name} ({Math.round(file.size / 1024)} KB)
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <label htmlFor="coverLetter" className="block text-sm font-medium text-gray-700 mb-1">
                      Cover Letter (Optional)
                    </label>
                    <textarea
                      id="coverLetter"
                      name="coverLetter"
                      value={formData.coverLetter}
                      onChange={handleInputChange}
                      rows="4"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    ></textarea>
                  </div>

                  <div className="pt-2">
                    <button
                      type="submit"
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition font-medium"
                    >
                      Submit Application
                    </button>
                  </div>
                  <input type="hidden" name="skills" value={JSON.stringify(formData.skills)} />
                </form>

                <ToastContainer />
              </div>


            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Scroll-to-top Button */}
      <AnimatePresence>
        {showScrollTop && (
          <motion.button
            onClick={scrollToTop}
            className="fixed right-4 sm:right-6 bottom-4 sm:bottom-6 z-50 p-2 sm:p-3 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-300 hover:shadow-xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
            aria-label="Scroll to top"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 sm:h-6 sm:w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;